import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Type } from '@spotify-internal/encore-creator-web';
import styles from './index.module.scss';
import {
  LOADING,
  ERROR,
  selectPodcastListeners,
  selectPodcastListenersStatus,
  selectDateRange,
} from 'store/selectors.ts';
import { loadPodcastListeners } from 'store/podcastListeners.ts';
import { PerformanceOverTimeChart } from 'components/Shared/Charts/PerformanceOverTimeChart';
import { LoadingIndicator } from 'components/Shared/LoadingIndicator';
import { FormattedMessage } from 'react-intl';

class PodcastListeners extends PureComponent {
  static propTypes = {
    listeners: PropTypes.arrayOf(
      PropTypes.shape({
        count: PropTypes.number,
        date: PropTypes.string,
      }).isRequired,
    ),
    status: PropTypes.oneOf([LOADING, ERROR]),
    podcastId: PropTypes.string.isRequired,
    loadPodcastListeners: PropTypes.func.isRequired,
    dateRange: PropTypes.shape({
      startDate: PropTypes.string.isRequired,
      endDate: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    }),
  };

  componentDidMount() {
    this.props.loadPodcastListeners(this.props.podcastId);
  }

  /* istanbul ignore next */
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (!this.props.dateRange) return;

    if (
      nextProps.dateRange.startDate !== this.props.dateRange.startDate ||
      nextProps.dateRange.endDate !== this.props.dateRange.endDate
    ) {
      this.props.loadPodcastListeners(this.props.podcastId);
    }
  }

  render() {
    const { status, listeners } = this.props;

    switch (status) {
      case ERROR:
        return <span data-qa="podcast-listeners-error" />;
      default:
        break;
    }

    if (!listeners && status !== LOADING) return null;

    return (
      <div data-qa="podcast-listeners-chart" className={styles.container}>
        <Type as="p" variant={Type.heading3}>
          <FormattedMessage id="podcast.audience.listeners" defaultMessage="Listeners" />
        </Type>
        {status === LOADING ? (
          <div style={{ width: '100%', height: '350px' }}>
            <LoadingIndicator />
          </div>
        ) : (
          <PerformanceOverTimeChart performanceData={listeners} name="Listeners" />
        )}
      </div>
    );
  }
}

const selectors = createStructuredSelector({
  status: selectPodcastListenersStatus,
  listeners: selectPodcastListeners,
  dateRange: selectDateRange,
});

const actions = {
  loadPodcastListeners,
};

export const ConnectedPodcastListeners = connect(selectors, actions)(PodcastListeners);
